import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[nimbusPrimaryNoBorderButton]',
  standalone: false,
})
export class NimbusMaterialNoBorderPrimaryButtonDirective implements OnInit {
  @Input() public colorVar?: string;
  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'nimbus-material-no-border-button');
    this.renderer.addClass(this.elementRef.nativeElement, 'primary');
    if (this.colorVar) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'color', `var(${this.colorVar})`);
    }
  }
}
